import React from "react";
import Configurator from "./configurator";
import { useHistory } from "react-router-dom";
import { useData } from "shared/hooks/use-data";
import { Loading } from "shared/ui/loading";
import { useRenderedOnClient } from "shared/hooks/use-rendered-on-client";
import { buildUrlQueryFromState, useInitialStateFromUrl } from "./helpers";
import { useSiteAreaContext } from "../../../shared/context/site-area";
import { getUrlVars } from "../../../shared/utils/url";

const ConfiguratorContainer = (props) => {
  const { filterSiteArea } = useSiteAreaContext()
  const { state, result } = useData(`/api/configurator?area=${filterSiteArea}`);
  const history = useHistory();
  const isLoading = state === "PENDING";
  const isRenderedOnClient = useRenderedOnClient();
  const initialStateFromUrl = useInitialStateFromUrl(isRenderedOnClient);

  const changeUrlStateString = (configuratorState) => {
    //setIsDirty(true)
    const currentUrlVars = getUrlVars()
    history.replace({ search: buildUrlQueryFromState(configuratorState, currentUrlVars) });
    window.parent.postMessage(
      {
        type: "CONFIGURATOR_STATE_CHANGE",
        data: buildUrlQueryFromState(configuratorState, currentUrlVars),
      },
      "*"
    );

  };

  const submitHandler = (configuratorState) => {
    console.log("Submitting configurator state", configuratorState);
    window.parent.postMessage(
      {
        type: "CONFIGURATOR_SUBMIT",
        data: configuratorState,
      },
      "*"
    );
  }

  return (
    <>
      {!isLoading ? (
        <Configurator
          initialState={initialStateFromUrl}
          onChange={changeUrlStateString}
          onSubmit={submitHandler}
          isEmbedded
          data={result}
        />
      ) : (
        <Loading />
      )}
    </>
  );
};

export default ConfiguratorContainer;
